import React from 'react';

export const NavMenuContext = React.createContext<{
  menuVisible: boolean;
  setMenuVisible: (isVisible: boolean) => void;
}>({
  menuVisible: false,
  setMenuVisible: (isVisible: boolean) => {},
});
